import { render, staticRenderFns } from "./myClaims.vue?vue&type=template&id=0237b214&scoped=true&"
import script from "./myClaims.vue?vue&type=script&lang=js&"
export * from "./myClaims.vue?vue&type=script&lang=js&"
import style0 from "./myClaims.vue?vue&type=style&index=0&id=0237b214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237b214",
  null
  
)

export default component.exports